export default "__VITE_ASSET__DlagpjH0__"